export default __webpack_public_path__ + "static/media/pic11-after.c66a9a08.jpg";